import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PublicFooter } from "../components/PublicFooter";

/** Legal pages render /public/legal/<slug>.<lang>.md — edit those markdown files to change the texts. */
const PAGES = { privacy: "Privacy Policy", terms: "Terms of Service", cookies: "Cookie Policy" };

function inline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") ? <strong key={i} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong> : part
  );
}

function md(src) {
  return src.split(/\n{2,}/).map((block, i) => {
    const b = block.trim();
    if (b.startsWith("# ")) return <h1 key={i} className="text-3xl font-semibold tracking-tight mt-2">{b.slice(2)}</h1>;
    if (b.startsWith("## ")) return <h2 key={i} className="text-lg font-semibold mt-6">{b.slice(3)}</h2>;
    if (b.startsWith("### ")) return <h3 key={i} className="text-sm font-semibold mt-4 text-slate-900">{b.slice(4)}</h3>;
    if (b.startsWith("- ")) return <ul key={i} className="list-disc pl-5 text-sm text-slate-700 space-y-1">{b.split("\n").map((l, j) => <li key={j}>{inline(l.replace(/^- /, ""))}</li>)}</ul>;
    if (b.startsWith("_") && b.endsWith("_")) return <p key={i} className="text-xs text-slate-500 italic">{b.slice(1, -1)}</p>;
    return <p key={i} className="text-sm text-slate-700 leading-relaxed">{inline(b)}</p>;
  });
}

export default function LegalPage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;
  const [lang, setLang] = useState(localStorage.getItem("pm_lang") || "en");
  const [text, setText] = useState("");
  useEffect(() => { fetch(`/legal/${slug}.${lang}.md`).then((r) => (r.ok ? r.text() : `# ${PAGES[slug] || slug}\n\n(Text follows.)`)).then(setText); }, [slug, lang]);
  return (
    <div className="min-h-screen bg-[#f6f7f4] flex flex-col" data-testid={`legal-${slug}`}>
      <div className="max-w-2xl w-full mx-auto px-5 py-10 flex-1">
        <div className="flex items-center justify-between mb-6 text-xs">
          <Link to="/" className="text-slate-500 hover:text-slate-900">← Playmaker</Link>
          <div className="flex gap-1">{["en", "nl"].map((l) => <button key={l} onClick={() => { setLang(l); localStorage.setItem("pm_lang", l); }} className={`px-2 py-1 rounded ${lang === l ? "bg-slate-900 text-white" : "text-slate-500"}`} data-testid={`legal-lang-${l}`}>{l.toUpperCase()}</button>)}</div>
        </div>
        <article className="space-y-3" data-testid="legal-content">{md(text)}</article>
        <nav className="mt-10 flex gap-4 text-xs text-slate-500">{Object.keys(PAGES).map((p) => <Link key={p} to={`/${p}`} className={p === slug ? "font-semibold text-slate-900" : ""}>{PAGES[p]}</Link>)}</nav>
      </div>
      <div className="border-t border-slate-200 bg-white"><div className="max-w-2xl mx-auto px-5 py-5"><PublicFooter /></div></div>
    </div>
  );
}
